import { defaultAccountCopy } from "@loot-os/api-contract";
import type { EndUser } from "@loot-os/client";
import type { AccountAdvancedContent } from "@loot-os/design-system/templates/account/accountContent";

import { useUpdateAutoClaim } from "../../../../lib/revealClaim.js";
import { useTerminology } from "../../../../lib/terminology.js";

/**
 * Settings → Advanced: the auto-claim switch, PUT /v1/me/settings. The same preference the claim
 * prompt offers, as a standing switch: on, each box reveal and battle result is claimed the
 * moment it lands, so the prompt never appears.
 */
export function useAdvancedContent({
  me,
  setError,
}: {
  me: EndUser | null;
  setError: (message: string | null) => void;
}): AccountAdvancedContent {
  const copy = defaultAccountCopy(useTerminology()).advanced;
  const setAutoClaim = useUpdateAutoClaim();
  return {
    title: copy.title,
    toggles: [
      {
        id: "autoClaim",
        label: copy.autoClaim.label,
        description: copy.autoClaim.description,
        checked: me?.autoClaim ?? false,
        disabled: !me || setAutoClaim.isPending,
        onCheckedChange: (checked) => {
          setError(null);
          setAutoClaim.mutate(checked, {
            onError: () => setError("Could not save the auto-claim setting. Try again."),
          });
        },
        stateLabels: { on: copy.on, off: copy.off },
      },
    ],
  };
}
